import styled from "styled-components";

export const UploadSectionWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  padding:12px;
`;

export const UploadButton = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px;
  gap: 8px;
  isolation: isolate;
  width: 145px;
  height: 40px;
  background: #2C589B;
  border: 0;
  border-radius: 2px;
  color: var(--color-contrast-white);
  cursor: pointer;
  font-size: 16px;
  font-weight: var(--font-weight-semibold);
  line-height: 1;
  white-space: nowrap;

  &:hover:not(:disabled) {
    background: var(--color-action-hover);
  }

  &:disabled {
    opacity: 0.65;
    cursor: not-allowed;
  }
`;

export const UploadButtonIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
`;
